module.exports = __webpack_public_path__ + "static/media/Fiddler-logo.a37c284d.png";